import styled from 'styled-components';

export const ProfileIconWrapperStyled = styled.div`
    display: inline-block;
    position: relative;
`;

export const ProfileIndicatorStyled = styled.div`
    width: 8px;
    height: 8px;
    border-radius: 4px;
    border: 1px solid var(--app-bg-color);
    background: #ff646c;
    position: absolute;
    bottom: 0;
    left: 14px;
`;